

module.exports = __webpack_require__.stylable.create(
    "ColorIndicator988273370",
    {"classes":{"root":"ColorIndicator988273370__root","ColorIndicator":"ColorIndicator988273370__ColorIndicator","AllDayColorIndicatorBack":"ColorIndicator988273370__AllDayColorIndicatorBack"},"vars":{},"stVars":{"ColorIndicatorWidth":"'\"unit(fallback(--eventTimeIndicatorWidth, 2), px)\"'","EventCornerRadius":"'\"unit(fallback(--eventCornerRadius, 0), px)\"'"},"keyframes":{}},
    "",
    1,
    "ColorIndicator988273370",
    null
);
